const mapTab = (() => {
  if (document.querySelector("body#pageMap") !== null) {

    const jsMapWrap = document.getElementById('jsMapWrap');
    const tabBtn = jsMapWrap.querySelectorAll('.js_tab_btn');
    const tabCnt = jsMapWrap.querySelectorAll('.js_tab_cnt');

    for (let i = 0; i < tabBtn.length; i++) {
      tabBtn[i].addEventListener("click", () => {

        for (let j = 0; j < tabBtn.length; j++) {
          if (!(j == i)) {
            tabBtn[j].classList.remove("act");
            tabCnt[j].classList.remove("act");
          } else {
            tabBtn[j].classList.add("act");
            tabCnt[j].classList.add("act");
          }
        }
      });
    }


  }
})();
export default mapTab;